(function() {
    'use strict';
    angular
        .module('quantixApp')
        .controller('CompanyReportAlertController', CompanyReportAlertController);

        CompanyReportAlertController.$inject = ['$scope', 'GenericServiceNew', 'CompanyReportService', '$http', '$window'];

    function CompanyReportAlertController($scope, GenericServiceNew, CompanyReportService, $http, $window) {

        $scope.showError = false;
        $scope.selectedAlert = {
            companies: [],
            alertType: {
                interimFin: false,
                detailFin: false,
                quarterlyFin: false,
                sharePriceMov: false,
                bondYieldMov: false,
                relatedRatingMov: false,
                ratingOutlook: false,
                ratingMov: false,
                ecoOutlook: false,
                indOutlook: false,
                irs: false,
                fsm: false,
                scorecard: false,
                ratingWatch: false
            },
            frequency: 'monthly'
        };
        $scope.primaryPoints = {
            crisilAnalytics: false,
            crisilOutlook: false,
            ratings: false,
            annualFin: false,
            quarterlyFin: false,
            capMarketMov: false,
            relatedComp: false
        }
        $scope.message = '';
        $scope.primaryDataPoints = false;
        $scope.companies = [];
        $scope.selectedCompanies = [];
        $scope.otherSelection = [];
        $scope.showSelection = [];

        $scope.ifInputsInvalid = function() {
            return (!$scope.selectedAlert.alertType.interimFin && !$scope.selectedAlert.alertType.detailFin && !$scope.selectedAlert.alertType.quarterlyFin
            && !$scope.selectedAlert.alertType.sharePriceMov && !$scope.selectedAlert.alertType.bondYieldMov && !$scope.selectedAlert.alertType.relatedRatingMov
            && !$scope.selectedAlert.alertType.ratingOutlook && !$scope.selectedAlert.alertType.ratingMov && !$scope.selectedAlert.alertType.ecoOutlook
            && !$scope.selectedAlert.alertType.indOutlook && !$scope.selectedAlert.alertType.irs && !$scope.selectedAlert.alertType.fsm && !$scope.selectedAlert.alertType.ratingWatch
            && !$scope.selectedAlert.alertType.scorecard) || ($scope.showSelection.concat($scope.otherSelection).length == 0) || (!$scope.selectedAlert.frequency);
        }

        $scope.getCompaniesForAlert = function() {
            CompanyReportService.getCompaniesForAlert().then(function(response) {
                $scope.selectedCompanies = response;
                $scope.companies = response;
                // if($scope.selectedCompanies.length > 7) {
                //     $scope.showSelection = $scope.selectedCompanies.slice(0, 7);
                //     $scope.otherSelection = $scope.selectedCompanies.slice(7, ($scope.companies.length-1));
                // } else {
                //     $scope.showSelection = $scope.selectedCompanies;
                // }
            }, function(error) {}
        );
        }

        $scope.setAlert = function() {
            $scope.message = '';
            if($scope.otherSelection.length > 0) {
                $scope.selectedAlert.companies = $scope.showSelection.concat($scope.otherSelection);
            } else {
                $scope.selectedAlert.companies = $scope.showSelection;
            }
            CompanyReportService.setAlert($scope.selectedAlert).then(
				function(successData) {
					$scope.message = successData.data;
                    $scope.isError = false;
					$scope.responseMessage = successData.data;
				}, function (errorData) {
					$scope.message = errorData.data;
                    $scope.isError = false;
					$scope.responseMessage = errorData.data;
				 }
			);
        }

        $scope.closeAlert = function() {
            $scope.message = '';
        }

        $scope.getName = function(name) {
            if(name) {
                return name.length > 18 ?  name.substring(0, 18)+ '...' : name;
            } else {
                return '';
            }
            
        }

        $scope.removeElement = function(type, index, company) {
            if(type == 'displayed') {
                $scope.showSelection.splice(index, 1);
                if($scope.otherSelection.length > 0) {
                    var removedElement = $scope.otherSelection.shift();
                    $scope.showSelection.push(removedElement);
                }
            } else {
                $scope.otherSelection.splice(index, 1);
            }
            $scope.selectedCompanies.splice(_.findIndex($scope.selectedCompanies, ['id', company.id]), 1);
        }

        $scope.changeSecondaryPoints = function(pointNumber) {
            switch (pointNumber) {
                case 1:
                    $scope.selectedAlert.alertType.fsm = $scope.primaryPoints.crisilAnalytics;
                    $scope.selectedAlert.alertType.scorecard = $scope.primaryPoints.crisilAnalytics;
                    $scope.selectedAlert.alertType.irs = $scope.primaryPoints.crisilAnalytics;
                    break;
                case 2:
                    $scope.selectedAlert.alertType.indOutlook = $scope.primaryPoints.crisilOutlook;
                    $scope.selectedAlert.alertType.ecoOutlook = $scope.primaryPoints.crisilOutlook;
                    break;
                case 3:
                    $scope.selectedAlert.alertType.ratingMov = $scope.primaryPoints.ratings;
                    $scope.selectedAlert.alertType.ratingOutlook = $scope.primaryPoints.ratings;
                    $scope.selectedAlert.alertType.ratingWatch = $scope.primaryPoints.ratings;
                    break;
                case 4:
                    $scope.selectedAlert.alertType.interimFin = $scope.primaryPoints.annualFin;
                    $scope.selectedAlert.alertType.detailFin = $scope.primaryPoints.annualFin;
                    break;
                case 5:
                    $scope.selectedAlert.alertType.quarterlyFin = $scope.primaryPoints.quarterlyFin;
                    break;
                case 6:
                    $scope.selectedAlert.alertType.sharePriceMov = $scope.primaryPoints.capMarketMov;
                    $scope.selectedAlert.alertType.bondYieldMov = $scope.primaryPoints.capMarketMov;
                    break;
                case 7:
                    $scope.selectedAlert.alertType.relatedRatingMov = $scope.primaryPoints.relatedComp;
                    break;
                default:
                    $scope.selectedAlert.alertType.fsm = $scope.primaryPoints.crisilAnalytics;
                    $scope.selectedAlert.alertType.scorecard = $scope.primaryPoints.crisilAnalytics;
                    $scope.selectedAlert.alertType.irs = $scope.primaryPoints.crisilAnalytics;
                    $scope.selectedAlert.alertType.indOutlook = $scope.primaryPoints.crisilOutlook;
                    $scope.selectedAlert.alertType.ecoOutlook = $scope.primaryPoints.crisilOutlook;
                    $scope.selectedAlert.alertType.ratingMov = $scope.primaryPoints.ratings;
                    $scope.selectedAlert.alertType.ratingOutlook = $scope.primaryPoints.ratings;
                    $scope.selectedAlert.alertType.ratingWatch = $scope.primaryPoints.ratings;
                    $scope.selectedAlert.alertType.interimFin = $scope.primaryPoints.annualFin;
                    $scope.selectedAlert.alertType.detailFin = $scope.primaryPoints.annualFin;
                    $scope.selectedAlert.alertType.quarterlyFin = $scope.primaryPoints.quarterlyFin;
                    $scope.selectedAlert.alertType.sharePriceMov = $scope.primaryPoints.capMarketMov;
                    $scope.selectedAlert.alertType.bondYieldMov = $scope.primaryPoints.capMarketMov;
                    $scope.selectedAlert.alertType.relatedRatingMov = $scope.primaryPoints.relatedComp;
                    break;
            }
        }

        $scope.changePrimaryDataPoints = function() {
            $scope.primaryPoints.crisilAnalytics = $scope.primaryPoints.crisilOutlook = $scope.primaryPoints.ratings = $scope.primaryPoints.annualFin = $scope.primaryPoints.quarterlyFin = $scope.primaryPoints.capMarketMov = $scope.primaryPoints.relatedComp = $scope.primaryDataPoints
            $scope.changeSecondaryPoints();
        }

        $scope.searchFilterForCompanyProfile = function (typedthings) {
            $scope.showError = false;
            $scope.companyCode = "";
			if (typedthings == "cleanData") {
				$scope.companies = null;
			} else {
                var commaSeparatedComp = '';
                for (var index = 0; index < $scope.selectedCompanies.length; index++) {
                    commaSeparatedComp = commaSeparatedComp + "'" + $scope.selectedCompanies[index].id + "',"
                }
				CompanyReportService.getCompaniesListByNameForCompanyReportAlert(typedthings, commaSeparatedComp)
					.then(function (data) {
                            //$scope.companies = data;
                            if(data) {
                                for (var index = 0; index < $scope.selectedCompanies.length; index++) {
                                    const element = $scope.selectedCompanies[index];
                                    var ind = _.findIndex(data, ['id', element.id]);
                                    console.log(ind);
                                    if(ind > -1) {
                                        data.splice(ind, 1);
                                    }
                                }
                                $scope.companies = data.concat($scope.selectedCompanies);
                                if ($scope.companies.length == 0) {
                                    $scope.showError = true;
                                    $scope.errorMessages = "Please select a company from the suggested list.";
                                }
                            }
						}, function (errordata) {
							$scope.showError = true;
							$scope.errorMessages = "Error while searching company!";
					});
			}
            // if(typedthings == "") {
            //     $scope.companies = $scope.companies.concat($scope.selectedCompanies);
            // }
        }

        $scope.$on('inputLabel', function (event, data) {
            $scope.searchFilterForCompanyProfile(data);
        });

        $scope.$watch('selectedCompanies', function (event, data) {
            if(event.length > 0 || data.length > 0) {
                if(event.length > data.length) {
                    for (var index = 0; index <= _.differenceWith(event, data, _.isEqual).length; index++) {
                        $scope.selectCompany(_.differenceWith(event, data, _.isEqual)[index]);
                    }
                } else {
                    if(_.differenceWith(data, event, _.isEqual).length < 2) {
                        for (var index = 0; index <= _.differenceWith(data, event, _.isEqual).length; index++) {
                            var compObj = _.differenceWith(data, event, _.isEqual)[index];
                            if(compObj) {
                                var indexShow = _.findIndex($scope.showSelection, ['id', compObj.id]);
                                if(indexShow >= 0) {
                                    $scope.showSelection.splice(indexShow, 1);
                                    if($scope.otherSelection.length > 0) {
                                        var removedElement = $scope.otherSelection.shift();
                                        $scope.showSelection.push(removedElement);
                                    }
                                } else {
                                    var indexOther = _.findIndex($scope.otherSelection, ['id', compObj.id]);
                                    $scope.otherSelection.splice(indexOther, 1);
                                }
                                //$scope.selectedCompanies.splice(_.findIndex($scope.selectedCompanies, ['id', compObj.id]), 1);
                            }
                        }
                    } else {
                        $scope.showSelection = [];
                        $scope.otherSelection = [];
                    }
                    
                }
            }
        });

        $scope.selectCompany = function (companyObj) {
                if(companyObj) {
                    if ($scope.showSelection.length >= 7) {
                        if(_.findIndex($scope.otherSelection, ['id', companyObj.id]) < 0) {
                            $scope.otherSelection.push(companyObj);
                        }
                    } else {
                        if(_.findIndex($scope.showSelection, ['id', companyObj.id]) < 0) {
                            $scope.showSelection.push(companyObj);
                        }
                    }
                }
        }

        $scope.resetAlert = function() {
            // $scope.selectedAlert.companies = [];
            // $scope.selectedAlert.frequency = 'monthly';
            // $scope.primaryDataPoints = false;
            // $scope.changePrimaryDataPoints();
            // $scope.selectedCompanies = [];
            // $scope.showSelection = [];
            // $scope.otherSelection = [];
        }

        $scope.itemTracker= function(item) {
            return item.id + '-' + item.name;
          }
        $window.scroll(0,0);
    }
})();